module.exports = __webpack_public_path__ + "img/image20.c1163caa.png";